if (!customElements.get('f-cart-goal')) {
    class FCartGoal extends HTMLElement {
        constructor() {
            super()

            this.selectors = {
                cartDrawer: '.drawer__inner',
                leftToSpend: '[data-left-to-spend]',
                cartGoalTitle: '.f-cartgoal__title'
            }

            this.confettiShow = false
            this.goalDone = false
            this.goal = Number(this.dataset.cartGoal) * Number(window.Shopify.currency.rate || 1) || 0
            this.money_format = window.theme?.settings?.moneyFormat
            this.enableConfetti = this.dataset.enableConfetti === 'true'
        }

        connectedCallback() {
            this.updateCartGoal(Number(this.dataset.cartTotal))

            document.addEventListener('cart:updated', event => {
                this.updateCartGoal(event.detail.cart.total_price)
            })

            document.addEventListener('product-form:cart:update', event => {
                this.updateCartGoal(event.detail.cart.total_price)
            })

            document.addEventListener('ajaxProduct:added', () => {
                fetch(`${window.Shopify.routes.root}cart.js`)
                    .then(response => response.json())
                    .then(cart => this.updateCartGoal(cart.total_price))
                    .catch(() => {})
            })

            this.confettiShow = this.goalDone
        }

        updateCartGoal(state) {
            if (state > 0) {
                this.classList.remove('hidden')
            } else {
                this.classList.add('hidden')
            }

            // if we want to stop including gift cards in the free shipping bar, uncomment this
            // this.toggleVisibility();

            this.cartTotal = state / 100
            this.goalLeft = this.goal - this.cartTotal
            this.goalDone = this.goalLeft <= 0

            this.percent = (this.cartTotal * 100) / this.goal

            if (this.percent >= 100) this.percent = 100

            if (this.cartTotal >= this.goal) {
                this.style.setProperty('--progress', `${this.percent}%`)
                this.classList.add('f-cartgoal--done', 'shakeY')
                this.dataset.total = this.cartTotal
            } else {
                let spend = (this.goal - this.cartTotal) * 100
                this.querySelector(this.selectors.leftToSpend).innerHTML = theme.Currency.formatMoney(spend, this.money_format)
                this.classList.remove('f-cartgoal--done', 'shakeY')
                this.style.setProperty('--progress', `${this.percent}%`)
                this.dataset.total = this.cartTotal
            }

            if (this.goalLeft <= 0 && this.enableConfetti) {
                this.showConfetti()
            } else {
                this.confettiShow = false
            }
        }

        toggleVisibility() {
            const drawer = this.closest('#CartDrawer');
            if ( drawer != null ) {
                const drawerItems = drawer.querySelectorAll( '[data-is-gc]' );
                const drawerItemsThatAreGiftCards = drawer.querySelectorAll( '[data-is-gc="true"]' );
                if ( drawerItems.length > 0 ) {
                    if ( drawerItems.length == drawerItemsThatAreGiftCards.length ) {
                        this.setAttribute( 'data-only-gc-cart' , 'true' );
                    } else {
                        this.setAttribute( 'data-only-gc-cart' , 'false' );
                    }
                }                
            }
        }

        showConfetti() {
            const cartDrawer = this.closest(this.selectors.cartDrawer)
            if (!this.confettiShow && cartDrawer) {
                setTimeout(() => {
                    new window.ShopifyConfetti(cartDrawer);
                    this.confettiShow = true
                }, 800)
            }
        }
    }

    customElements.define('f-cart-goal', FCartGoal)
}
